import React, { useEffect, useRef } from 'react';
import ReactQuill, { Quill } from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { modules } from '../../utils/QuilModule';

// Custom line-height attributor
const Parchment = Quill.import('parchment');
class LineHeightAttributor extends Parchment.Attributor.Style {
  constructor() {
    super('lineHeight', 'line-height', {
      scope: Parchment.Scope.INLINE,
      whitelist: ['1.0', '1.2', '1.5', '1.8', '2.0', '2.5', '3.0']
    });
  }
}
const LineHeightStyle = new LineHeightAttributor();
Quill.register(LineHeightStyle, true);

const QuillInput = ({ value, onChange, onFocus, onBlur, placeholder, style, editingElement, fieldName }) => {
  const quillRef = useRef(null);
  const colorPickerStyles = `
    .ql-snow .ql-picker.ql-color-picker .ql-picker-label {
      padding: 2px 4px;
    }
    .ql-snow .ql-picker.ql-color-picker .ql-picker-item {
      height: 20px;
      width: 20px;
      border-radius: 3px;
      margin: 2px;
      float: left;
    }
    .ql-color-picker .ql-picker-options {
      width: 342px !important;
      padding: 4px;
    }
    .ql-line-height .ql-picker-item::before {
      content: attr(data-value) !important;
    }
    .ql-line-height .ql-picker-label::before {
      content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cline x1='3' y1='12' x2='21' y2='12'%3E%3C/line%3E%3Cline x1='3' y1='6' x2='21' y2='6'%3E%3C/line%3E%3Cline x1='3' y1='18' x2='21' y2='18'%3E%3C/line%3E%3C/svg%3E") !important;
      display: inline-block;
      vertical-align: middle;
    }
  `;

  useEffect(() => {
    if (quillRef.current && editingElement === fieldName) {
      // Focus the editor when editingElement matches this field
      quillRef.current.focus();
    }
  }, [editingElement, fieldName]);

  return (
    <div className="quill-editor-container">
      <style>{colorPickerStyles}</style>
      <ReactQuill
        ref={quillRef}
        value={value}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        placeholder={placeholder}
        theme="snow"
        style={style}
        modules={modules}
      />
    </div>
  );
};

export default QuillInput;